export default "__VITE_ASSET__BTkkexuV__"